import { RemoteContests } from '../../../data/usecases/contests/remote-contests'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeContestsVacancies = (type: 'concursos' | 'jobs' = 'concursos') => {
  const endpoint = type === 'concursos' ? '/concursos' : '/jobs'
  return new RemoteContests(endpoint, makeAxiosHttpClient())
}
